export default __webpack_public_path__ + "static/media/warning.5ee76b56.svg";